import
  React, {
  useContext
} from 'react';

import
  PropTypes
from 'prop-types';

import {
  useHistory
} from 'react-router-dom';

import {
  Carousel,
  VContainer,
  VContainerV,
  VContainerVH
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  FeedProvider
} from '../providers';

import {
  AdNames,
  Ads,
  CustomColors,
  ErrorKeys,
  FeatureToggles
} from '../../../constants';

import {
  HandleRender
} from 'hocs';

import {
  Base64ImageCard
} from '.';

import {
  AdSlot
} from 'components';

import {
  handleUtagLinkEvent,
  isEqual,
  isFeatureEnabled
} from 'helpers';

import {
  AppContext
} from 'context';

export const RssCarousel = props => {

  const { config } = useContext(AppContext);

  const [
    state,
    setState
  ] = React.useState({
    rssFeeds: [],
    loading: false,
    error: null,
    images: {}
  });

  const history = useHistory();

  const firstUpdate = React.useRef(true);

  React.useEffect(() => {

    let isMounted = true;

    const getRssFeeds = async () => {

      if (!Array.isArray(props.feedsInformation)) {
        return;
      }

      const feedsInfo = {};
      feedsInfo.category = props.feedCategory;
      feedsInfo.names = [];

      props.feedsInformation?.forEach((feed, index) => {

        feedsInfo.names.push(feed.name);
      });

      if (!feedsInfo?.names?.length) {
        return;
      }

      const response = await FeedProvider.getBatchFeeds(
        props.feedCategory,
        JSON.stringify(feedsInfo),
        props.rssFeedLimit
      );

      if (!isMounted) {
        return;
      }

      if (!response || !response.ok || !response?.result || !response.result.length) {

        handleUtagLinkEvent({
          content_title: `cbu: connectu: rss feed: ${props.feedCategory}`,
          page_section: 'rss feed components',
          content_feed_events: 'content_error'
        });

        setState(prevState => ({
          ...prevState,
          loading: false,
          error: response?.error || true
        }));
        return;
      }

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: false,
        rssFeeds: response.result
      }));

      const { googletag } = window;

      if (!firstUpdate.current) {

        googletag?.cmd?.push?.(() => {

          const slots = googletag?.pubads?.()?.getSlots?.();
          const carouselSlot = slots?.find?.(slot => slot?.getSlotId?.()?.getName?.() === Ads[AdNames.NewsCarousel]?.slot);

          googletag?.pubads?.()?.refresh?.([ carouselSlot ]);
        });
      }

      firstUpdate.current = false;
    };

    if (!props.feedCategory || !props.feedsInformation) {
      return;
    }

    const init = async () => {

      setState(prevState => ({
        ...prevState,
        loading: true,
        error: null
      }));

      await getRssFeeds();
    };

    init();

    return () => {
      isMounted = false;
      setState(prevState => ({
        ...prevState,
        rssFeeds: []
      }));
    };

  }, [ props.feedCategory, props.feedsInformation, props.rssFeedLimit ]);

  const generateRssTiles = () => {

    let rssTiles = [];

    if (!state.rssFeeds?.length > 0) {
      return rssTiles;
    }

    for (const companyFeed of state.rssFeeds) {

      let feeds = companyFeed.items;
      const defaultImagePath = props.feedsInformation?.find(element => isEqual(element.name, companyFeed.name))?.defaultImage;

      for (const feed of feeds) {

        if (!feed || !feed.title || !feed.content || !defaultImagePath) {
          continue;
        }

        rssTiles.push(

          <VContainerVH
            key={`rss-carousel-${props.feedCategory}-${feed.newsArticleUrl}`}
            width={'100%'}
            minHeight={'600px'}
            margin={'0 13px 16px'}>

            <Base64ImageCard
              title={feed.title}
              text={feed.content}
              defaultImage={`${Environment.current.drupalBaseUrl}${defaultImagePath}`}
              imageId={feed.imageId}
              feedName={companyFeed.name}
              feedCategory={props.feedCategory}
              imageHeight={'240px'}
              imageObjectFit={'cover'}
              buttonText={'Read More'}
              subtitle={companyFeed.name}
              onClick={() => {

                handleUtagLinkEvent({
                  content_id: companyFeed?.name,
                  content_feed_events: 'content_click'
                });

                history.push({
                  pathname: '/news-content',
                  search: `?newsId=${encodeURIComponent(feed.newsArticleUrl)}&category=${encodeURIComponent(props.feedCategory)}`
                });
              }} />
          </VContainerVH>
        );
      }
    }

    if (isFeatureEnabled(config, FeatureToggles.EnableFuseAds)) {

      rssTiles.splice(
        Math.round(rssTiles.length / 2),
        0,
        <VContainerV
          key={`rss-carousel-${props.feedCategory}-ad`}
          width={'100%'}
          margin={'0 13px 16px'}
          borderRadius={'4px'}
          border={`solid 0.6px ${CustomColors.Grey5}`} >

          <AdSlot
            adId={AdNames.NewsCarousel}/>

        </VContainerV>
      );
    }

    return rssTiles;
  };

  const rssTileList = generateRssTiles();

  return (

    <HandleRender
      isLoading={state.loading}
      isError={state.error}
      error={{ type: ErrorKeys.General, title: props.feedCategory?.toUpperCase() }}>

      { rssTileList?.length &&

        <VContainer
          maxWidth={'100%'}>

          <Carousel
            componentList={rssTileList}
            autoSwipeTime={props.autoSwipeTime}
            slidesPerView={props.slidesPerView} />

        </VContainer>
      }

    </HandleRender>
  );
};

RssCarousel.propTypes = {
  feedCategory: PropTypes.string,
  feedsInformation: PropTypes.array,
  autoSwipeTime: PropTypes.number,
  slidesPerview: PropTypes.number
};

RssCarousel.defaultProps = {
  rssFeedLimit: 6,
  autoSwipeTime: 5000,
  slidesPerview: 1
};